if (!customElements.get("product-share")) {
  class ProductShare extends HTMLElement {
    connectedCallback() {
      if (this.hasBoundShare) return;
      this.hasBoundShare = true;

      this.button = this.querySelector(".product-share__button");
      this.message = this.querySelector(".product-share__message");
      this.button?.addEventListener("click", () => this.share());
    }

    get shareUrl() {
      const url = new URL(window.location.href);
      const variant = url.searchParams.get("variant");

      url.search = "";
      url.hash = "";
      if (variant) url.searchParams.set("variant", variant);

      return url.toString();
    }

    async share() {
      const url = this.shareUrl;

      if (navigator.share) {
        try {
          await navigator.share({
            title: this.dataset.shareTitle || document.title,
            url,
          });
        } catch (error) {
          if (error?.name !== "AbortError") this.copy(url);
        }
        return;
      }

      this.copy(url);
    }

    async copy(url) {
      try {
        await navigator.clipboard.writeText(url);
      } catch (error) {
        const input = document.createElement("input");
        input.value = url;
        input.setAttribute("readonly", "");
        input.style.position = "absolute";
        input.style.left = "-9999px";
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        input.remove();
      }

      this.showMessage();
    }

    showMessage() {
      if (!this.message) return;

      this.message.hidden = false;
      clearTimeout(this.messageTimer);
      this.messageTimer = setTimeout(() => {
        this.message.hidden = true;
      }, 2000);
    }
  }

  customElements.define("product-share", ProductShare);
}